import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import StepperComponent from "../../shared/StepperComponent";
import FinalizePage from "../FinalizePage";
import { getReservationConfig } from "../../store/config/configActions";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import { setActiveStep } from "../../store/basket/basketActions";
import AccountDefinitionView from "./AccountDefinitionView";
import useAccountDefinition from "./hooks/useAccountDefinition";
import getId from "../../utils/getId";
import { EXERCISE_RESERVATION } from "../../Routing/routes";

const container = { padding: "2%", minHeight: "70vh", width: "95%", overflow: "hidden" };
const lengthStepper = 2;

const AccountDefinition: React.FC<RouteComponentProps> = (props) => {
  const dispatch = useDispatch();
  const activeStep = useSelector((state: State) => state.basket.activeStep);
  const { isLoggedIn } = useSelector((state: State) => state.auth);
  const { loading, accountDepositDef, selectAccDepositDef, setSelectAccDepositDef } = useAccountDefinition();

  useEffect(
    () => {
      dispatch(getReservationConfig());
      if (!isLoggedIn) {
        props.history.push(EXERCISE_RESERVATION);
      }
    }, // eslint-disable-next-line
    []
  );

  const steps = [
    {
      label: "Wybór kwoty doładowania",
      component: (
        <AccountDefinitionView
          {...props}
          activeStep={activeStep}
          setActiveStep={(value: number) => dispatch(setActiveStep(value))}
          lengthStepper={lengthStepper}
          loading={loading}
          accountDepositDef={accountDepositDef}
          selectAccDepositDef={selectAccDepositDef}
          setSelectAccDepositDef={setSelectAccDepositDef}
        />
      ),
    },
    {
      label: "Finalizacja transakcji",
      component: (
        <FinalizePage
          {...props}
          action={"pay"}
          accDepositDefIds={getId(selectAccDepositDef)}
        />
      ),
    },
  ];
  return (
    <Box style={container}>
      <StepperComponent
        steps={steps}
        activeStep={activeStep}
        setActiveStep={(value: number) => dispatch(setActiveStep(value))}
      />
    </Box>
  );
};

export default AccountDefinition;
